// Resolves an in-page anchor element from a hash or href (e.g. "#1-bestil-filer-i-banken").
//
// Heading IDs are slugified from the heading text, so a heading like
// "1. Bestil filer i banken" produces the id "1-bestil-filer-i-banken", which
// starts with a digit. Passing "#1-..." to document.querySelector() throws a
// SyntaxError ("not a valid selector") because a CSS id selector cannot begin
// with an unescaped digit. getElementById() takes a raw id string and has none
// of those syntax restrictions, so it resolves numbered-step anchors correctly.
export const getAnchorElement = (hashOrHref) => {
  if (!hashOrHref) return null;

  const raw = hashOrHref.charAt(0) === '#' ? hashOrHref.slice(1) : hashOrHref;
  if (!raw) return null;

  // location.hash is percent-encoded for non-ASCII characters, while DOM ids
  // are literal, so try the decoded id first and fall back to the raw value.
  let decoded = raw;
  try {
    decoded = decodeURIComponent(raw);
  } catch (e) {
    // Malformed URI component — keep the raw value.
  }

  return document.getElementById(decoded) || document.getElementById(raw);
};
